import { memo } from 'react'

import { getImageUrl } from '@/constants/images'

const Logo = () => {
  return (
    <div className='ew-d-flex ew-justify-content-center'>
      <img alt='Paysense logo' height={36} src={getImageUrl('payufin_logo')} width={105} />
    </div>
  )
}

export default memo(Logo)
